// Combine all available reducers to a single root reducer.
import { combineReducers } from 'redux'
import flyers from './flyers.reducer'
import flyerGibs from './flyerGibs.reducer'
import products from './products.reducer'
import tags from './tags.reducer'
import brands from './brands.reducer'
import stores from './stores.reducer'
import user from './user.reducer'
import router from './router.reducer'
import ui from './ui.reducer'
import tracking from './tracking.reducer'
import viewer from './viewer.reducer'
import property from './property.reducer'
import application from './application.reducer'
import routerMatch from './routerMatch.reducer'
import dialog from './dialog.reducer'

const reducers = {
  flyers,
  flyerGibs,
  products,
  tags,
  brands,
  stores,
  user,
  ui,
  tracking,
  viewer,
  property,
  application,
  routerMatch,
  dialog,
}

export default history => combineReducers({
  router: router(history),
  ...reducers,
})
